<template>
    <div class="row">
        <!-- <div v-if="hasOverlapError" class="col-12">
            <b-alert variant="danger" class="p-25" show>
                <feather-icon icon="AlertCircleIcon" class="mr-50 ml-50" />
                Bir çalışan aynı anda hem Depo Sorumlusu hem de Veri İşlem Görevlisi olamaz.
            </b-alert>
        </div> -->
        <div class="col-12 mb-2">
            <label class="form-label">Veri İşlem Görevlisi </label>
            <v-select-list
                :value="value.DataProcessorIds"
                v-on:input="updateModel('DataProcessorIds', $event)"
                :options="allUsers"
                label="FullName"
                :reduce="(user) => user.Id"
                placeholder="Veri İşlem Görevlisi seçin"
                multiple
            />
        </div>

        <div class="col-12 mb-2">
            <label class="form-label">Depo Sorumlusu</label>
            <v-select-list
                :value="value.SupervisorIds"
                v-on:input="updateModel('SupervisorIds', $event)"
                :options="allUsers"
                label="FullName"
                :reduce="(user) => user.Id"
                placeholder="Depo Sorumlusu seçin"
                multiple
            />
        </div>
    </div>
</template>

<script>
import { BAlert } from 'bootstrap-vue';

export default {
    name: "FuelStorageEmployeeCreateOrUpdate",
    components: {
        BAlert,
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
        allUsers: {
            type: Array,
            default: () => [],
        },
        hasOverlapError: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        updateModel(key, selectedIds) {
            const updatedValue = { ...this.value, [key]: selectedIds };
            this.$emit("input", updatedValue);
        },
    },
};
</script>
